import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INITIAL_STORE, TABLE_FILTERS_SLICE_NAME } from "./constants";
import {
  TABLE_TABS_ENUM,
  TFiltersByTableName,
  TTableFiltersState,
} from "./types";

type ChangeFiltersPayload<T extends TABLE_TABS_ENUM = TABLE_TABS_ENUM> = {
  tableName: T;
  data: Partial<TFiltersByTableName<T>>;
};

const tableFiltersSlice = createSlice({
  name: TABLE_FILTERS_SLICE_NAME,
  initialState: INITIAL_STORE,
  reducers: {
    changeFiltersByTableName: (
      state,
      action: PayloadAction<ChangeFiltersPayload>
    ) => {
      const { tableName, data } = action.payload;
      state[tableName].filters = {
        ...state[tableName].filters,
        ...data,
      } as TTableFiltersState[typeof tableName]["filters"];
    },
    resetFiltersByTableName: (
      state,
      action: PayloadAction<TABLE_TABS_ENUM>
    ) => {
      const tableName = action.payload;
      state[tableName].filters = {
        ...INITIAL_STORE[tableName].filters,
      } as TTableFiltersState[typeof tableName]["filters"];
    },
  },
});

export const { changeFiltersByTableName, resetFiltersByTableName } =
  tableFiltersSlice.actions;

export default tableFiltersSlice;
